














import { Vue, Component, Inject, Prop } from "vue-property-decorator";

// Types
import {
  IProvisioningProvider,
  IProvisioningProviderMethods
} from "@/models/providers/contractProduct";

@Component
export default class CProdProvActions extends Vue {
  // Inject

  @Inject({ from: "cProdProvProvider" })
  public readonly $cProdProvProvider!: () => IProvisioningProvider;

  @Inject({ from: "cProdProvProviderMethods" })
  public readonly $provisioningMethods!: IProvisioningProviderMethods;

  // Props

  @Prop({ default: false })
  public readonly highlighted!: boolean;

  // Computed

  public get cProdProvData() {
    return this.$cProdProvProvider();
  }

  public get filteredFunctions() {
    return this.$_.filter(this.cProdProvData.cProdProvFunctions, func =>
      this.highlighted ? func.highlight : true
    );
  }

  // Methods

  public isExecuting(cProdProvFunction) {
    return this.$_.some(
      this.cProdProvData.executedFunctions,
      executedFunction => {
        return (
          executedFunction.id === cProdProvFunction.id &&
          !executedFunction.async
        );
      }
    );
  }
}
